export default __webpack_public_path__ + "static/media/36I-114280_-21045_0.6be605a9.jpg";